import { Button, Dialog, DialogActions, DialogTitle } from '@mui/material'
import StepperApGlobal from './Stepper'
import { FormProvider, useForm } from 'react-hook-form'
import PaperDraggable from '../../../../components/PaperDraggable'
import { useMutation, useQueryClient } from 'react-query'
import axiosClient from '../../../../lib/axios'
import { useModalDetalheProcesso } from '../../../../components/ModalContexts/ModalDetalheProcessoContext'
import { enqueueSnackbar } from 'notistack'

export default function DialogApGlobal({
    open,
    handleClose
}: DialogApGlobalProps) {

    const queryClient = useQueryClient();
    const { openModal } = useModalDetalheProcesso();

    //Querys e mutations
    const { mutate: solicitarCriacaoTitulo } = useMutation({
        mutationKey: "solicitar-criacao-ap-global",
        mutationFn: (inputs: any) =>
            axiosClient.post(
                "/financeiro/ap-global/solicitar-criacao-ap-global",
                inputs,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            ),
        onError: (error) => {
            console.error(error);
            enqueueSnackbar("Erro ao solicitar criação de autorização de pagamento!", {
                variant: "error",
            });
        },
        onSuccess: ({ data }) => {
            queryClient.invalidateQueries([
                "table-data-grid-financeiro/contas-pagar/pesquisar-titulos-pagar",
            ]);
            handleClose();
            enqueueSnackbar(`Processo #${data} criado com sucesso!`, {
                variant: "success",
            });
            openModal(data);
        },
        onSettled: () => setValue("isLoadingIncluirTitulo", false),
    });

    //Funções manipuladoras
    const handleNextStep = () => {
        const stepper = getValues('stepper')
        setValue('stepper', stepper + 1)
    }

    const handleBackStep = () => {
        const stepper = getValues('stepper')
        setValue('stepper', stepper - 1)
    }

    const onSubmit = (data: any) => {
        setValue("isLoadingIncluirTitulo", true);

        const params = {
            titulos: data.selecionar_titulos.map((item: any) => item.id),
        }
        solicitarCriacaoTitulo(params)
    };
    //

    const defaultValuesForm = {
        stepper: 0,
        isLoadingIncluirTitulo: false,
        preFilterStep: true,
        selecionar_titulos: [],
        qtd_titulos: 0,
        funcoesAux: {
            onNext: handleNextStep,
            onBack: handleBackStep,
            onCloseModal: handleClose,
            onSubmit: onSubmit,
        },
    }

    const methods = useForm({ defaultValues: defaultValuesForm })
    const { getValues, setValue } = methods

    return (
        <FormProvider {...methods}>
            <Dialog
                open={open}
                fullWidth
                maxWidth='lg'
                PaperComponent={PaperDraggable}
                aria-labelledby="draggable-dialog-title"
            >
                <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">Autorização de pagamento</DialogTitle>

                <StepperApGlobal />

                {
                    getValues('stepper') === 0 &&
                    <DialogActions>
                        <Button
                            onClick={handleClose}
                        >
                            Fechar
                        </Button>
                    </DialogActions>
                }
            </Dialog>
        </FormProvider>
    )
}

interface DialogApGlobalProps {
    open: boolean
    handleClose: () => void
}
